"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTMLVideoPlayButton = void 0;
var _styles = require("@material-ui/core/styles");

// Youtube play button for video content preview
// Can be generic but is used only for youtube video thumbnails
var HTMLVideoPlayButton = (0, _styles.styled)('div')({
  '&:before': {
    content: '""',
    top: 0,
    position: 'absolute',
    borderWidth: '8px 0 8px 16px',
    backgroundColor: 'rgba(0,0,0, 0.35)',
    width: '97%',
    height: '100%',
    borderRadius: '3px'
  },
  '&:after': {
    content: '""',
    borderColor: 'transparent transparent transparent #fff',
    borderStyle: 'solid',
    borderWidth: '8px 0 8px 16px',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate3d(-50%, -50%, 0)'
  }
});
exports.HTMLVideoPlayButton = HTMLVideoPlayButton;